var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPesto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 67,
    viewBox: "0 0 71 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.31905,
    y: 3.22211,
    width: 56.4369,
    height: 52.1459,
    rx: 11.2818,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_290",
    x: 0.544,
    y: 0.963758,
    width: 69.987,
    height: 65.696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5167
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.38752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_290",
    transform: "matrix(0.00444444 0 0 0.00481017 0 -0.0411443)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_290",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAflBMVEUAAAD///+KioqZmZnIyMgnJyeNjY3CwsLc3NyVlZV1dXWQkJDl5eVtbW2Li4teXl65ublMTEx7e3vW1tb29vampqY8PDxTU1ODg4NEREQtLS1vb29iYmJzc3M2NjZZWVkgICAODg7v7++ioqLX19fj4+MZGRmwsLBISEgUFBR1L5vaAAAEXklEQVR4nO3ZaXeqOhiGYaCKVpy1zq1Dq+3+/3/wMCThhQTdey84LM+5ry8tYTCPkIHoeQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwHG5BYtN2NRrU81Nh2/Vojkr42nY9mkPC5/e/SRi1XY/EOjF7eNhpsh8lDjtrz3E/0N6TgvNgMLpmCTt7Xaj9jDKHj9oSVDm+rpM/06wq6cj15c/dx96+l35uKkKepnKP73975v6JE/TRo4Us7q0ajOdtgzCcJP90sk97Sf4f+v71x3HwvFxl07z2rjCdcmFPHb0o73hrLN9uHo0DZ8K4Oufy0ZtyxXz/M9uztXbcSzi0r/PdTL7zKM4XVCU01de6dsV8P2u41k25l/DNdZ1REwGPUZhOGisT+suBPH7qqtki3WWXOxN2Kg6ODevPFzfAIHiQsNgc88LrtW/6lWTPwUToaUnvFV6G5krD2CXtxsyzfunL69Td23Tn6QP6MKFojh+qQD2772rz4OU9kDWAuMZD9Sgs1SgxUecGteZTDTAzfv0oJyy2lJfsJHWjlvoiqu2N438DcT/dCcWcZlEqUYlr7WuOYZjnizbZlykTelEhYtYcB9nGQl/lLa+pvp89+7PshP383qfCbHtqn/vX5pHJF7dFPYspJPS870LGZLyaVye86eOuVmuqTDjR20HtCVd5wDA8muJSQu9WmJHcTyhGi3JFH9/D+hPOTB8aHURxOWHc2/bzhB92wk9R9534MoorFi0mHEfvJ1lsJ4w7l4uu9i7vMBfKUtZ9JiIO5YSvvYTjTalrdyWMB6+llbBE1f0kbrjscdpLaL2wuRPqMeJhwni/fLkwk7D2Eobr30vY+e2EnvcqinVrbLEdRptiz+5M+KIrXJ2wMGUWY8ys9YRxVzOXTdGRUDx3ecLO3YvvzGxb9bltJPwxE5ow2t9MsZVwImenJ5PQMW8pMLPwbLONEf8s5qRiSCwlXBVe+a6embXdv4exkTonGzNUQvGq2S893VHtCb3dRk7bdJdTSPiruMSSPnHlmXclX94kNa/u57vVV2cWLjql7VqsxdQ7CDdn8UFpwokvXbL7fFKbvV/3L6571HVha2r6Nd0bqcUu3ZnV/ePNIcozZpNTmVCO3vmPKmaC4y8Nf5nU/PzVN0zvlH0RxRWc5Lu0Fq0y3ZoTeqeBaY5334DFa5tzfSW9FUdH+UWdVVh22iYlzst81R0wttqEDxMuClO7yoRrR7meNBWe+PRRDRxHZ9lrp5pjZcLLoXT8HyS8mrM+ywntleK61zCEtDlWJbR/a9he7Lq5n1I5pohl1q0dOrVvKmDcHOfR2J3QPT7NrZXR5OTSSuplWvr540V3XSdV0H0TzbPf8M82q03kSPh15/eSU1dQQ4cosZbK8yMKBefs8BoiPLROP0Um3DeyAt22iren/xASPj8SPr/ZNPWv9N4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAE/oHGNI1/cOiXPcAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesto);
export default __webpack_public_path__ + "static/media/pesto.a011c7b840899a4c16711a058dc4e6c4.svg";
export { ForwardRef as ReactComponent };